/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Page_Security_NoteInputs */

const en_login_page_security_note = /** @type {(inputs: Login_Page_Security_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privy secures the session. Glider never sees your email password or wallet key.`)
};

const de_login_page_security_note = /** @type {(inputs: Login_Page_Security_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privy sichert die Sitzung. Glider sieht weder Ihr E-Mail-Passwort noch Ihren Wallet-Schlüssel.`)
};

const pt_br2_login_page_security_note = /** @type {(inputs: Login_Page_Security_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A Privy protege a sessão. A Glider nunca vê sua senha de e-mail nem a chave da sua carteira.`)
};

const tr_login_page_security_note = /** @type {(inputs: Login_Page_Security_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privy oturumu güvence altına alır. Glider e-posta parolanızı veya cüzdan anahtarınızı hiçbir zaman görmez.`)
};

const zh_cn2_login_page_security_note = /** @type {(inputs: Login_Page_Security_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privy 负责保护会话安全。Glider 绝不会看到您的电子邮箱密码或钱包密钥。`)
};

const zh_hk2_login_page_security_note = /** @type {(inputs: Login_Page_Security_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privy 負責保障工作階段安全。Glider 絕不會看到你的電郵密碼或錢包密鑰。`)
};

const ko_kr2_login_page_security_note = /** @type {(inputs: Login_Page_Security_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privy가 세션을 보호합니다. Glider는 이메일 비밀번호나 지갑 키를 볼 수 없습니다.`)
};

const ru_ru2_login_page_security_note = /** @type {(inputs: Login_Page_Security_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privy защищает сессию. Glider никогда не видит пароль от вашей электронной почты или ключ кошелька.`)
};

const es_419_login_page_security_note = /** @type {(inputs: Login_Page_Security_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privy protege la sesión. Glider nunca ve la contraseña de tu correo electrónico ni la clave de tu billetera.`)
};

/**
* | output |
* | --- |
* | "Privy secures the session. Glider never sees your email password or wallet key." |
*
* @param {Login_Page_Security_NoteInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const login_page_security_note = /** @type {((inputs?: Login_Page_Security_NoteInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Page_Security_NoteInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_login_page_security_note(inputs)
	if (locale === "de") return de_login_page_security_note(inputs)
	if (locale === "pt-BR") return pt_br2_login_page_security_note(inputs)
	if (locale === "tr") return tr_login_page_security_note(inputs)
	if (locale === "zh-CN") return zh_cn2_login_page_security_note(inputs)
	if (locale === "zh-HK") return zh_hk2_login_page_security_note(inputs)
	if (locale === "ko-KR") return ko_kr2_login_page_security_note(inputs)
	if (locale === "ru-RU") return ru_ru2_login_page_security_note(inputs)
	return es_419_login_page_security_note(inputs)
});